import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import queryString from 'query-string';

export default function addMultipleToCart(params) {
    const { baseUrl, brandId, country, language, items, uberToken, clientId, clientSecret, includeShoppingCart, langId, additionalHeaders = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of addMultipleToCart()');
    invariant(brandId, 'brandId is a required param of addMultipleToCart()');
    invariant(country, 'country is a required param of addMultipleToCart()');
    invariant(language, 'language is a required param of addMultipleToCart()');
    invariant(items, 'items is a required param of addMultipleToCart()');
    invariant(uberToken, 'uberToken is a required param of addMultipleToCart()');
    invariant(clientId, 'clientId is a required param of addMultipleToCart()');

    const query = queryString.stringify({ langId, includeShoppingCart: includeShoppingCart ? 'Y' : undefined });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart${query ? `?${query}` : ''}`;
    const body = JSON.stringify({
        orderItem: items.map(({ partNumber, quantity, xitem_giftMessage, reservationId }) => ({
            partNumber,
            quantity,
            xitem_giftMessage,
            'xitem_attr-reservationId': reservationId,
        })),
    });
    const headers = { ...additionalHeaders };

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'POST', body }), uberToken, clientId, clientSecret),
        'addMultipleToCart',
    );
}
